module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "value-crud-action--delete"
  }, [_c('a', {
    on: {
      "click": _vm.unassign
    }
  }, [_c('i', {
    staticClass: "icon status-inactive"
  }, [_vm._v("clear")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a65a889e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValues/CollectionValueUnassign.vue
// module id = 1970
// module chunks = 0